module.exports = __webpack_public_path__ + "media/images/top_menu_icon/electronic_sales_owners-d1d6af3d13fe0d32753f464f8937426e.png";